import * as XLSX from "xlsx";
import AWS from "aws-sdk";
import { Buffer } from "buffer";

AWS.config.update({
  accessKeyId: "AKIAWCZC523CPFGSHMG6",
  secretAccessKey: "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",
  region: "us-east-1",
});

const s3 = new AWS.S3();

export function onSubmit(formData) {
  console.log("Form data:", formData);
  try {
    // 1. Create Excel sheet from formData
    const ws = XLSX.utils.json_to_sheet([formData]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Contact");

    // 2. Convert to Excel binary data
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // 3. Create Blob
    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // 4. Convert Blob to base64
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = async () => {
      const base64Data = reader.result.split(",")[1];
      await uploadExcelToS3(base64Data, formData);
    };
  } catch (error) {
    console.error("Error generating Excel:", error);
  }
}

// 👇 Normal internal function
async function uploadExcelToS3(base64Data, formData) {
  try {
    const fileContentBuffer = Buffer.from(base64Data, "base64");

    const params = {
      Bucket: "valacademy",
      Key: `Excel/Contact_${Date.now()}.xlsx`,
      Body: fileContentBuffer,
      ContentType:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ACL: "public-read",
    };

    const data = await s3.upload(params).promise();
    console.log("Uploaded Excel to:", data.Location);

    const response = await fetch(
      "https://7qhcbncwbj.execute-api.us-east-1.amazonaws.com/dev/oxygenefm/auth/valAcademyEmail",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: `${formData.nom} ${formData.prenom}`,
          url: data.Location,
        }),
      }
    );

    const result = await response.json();
    if (result.success) {
      alert("Email envoyé avec succès !");
    } else {
      alert("Échec de l'envoi de l'email.");
    }
  } catch (err) {
    console.error("Error during upload or email:", err);
    alert("Une erreur est survenue.");
  }
}
